// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"root_uM2nH flex items-center font-openSans","text":"text_U7q5c pr-1.25 font-normal","switch":"switch_R6XR1 ml-1.25"};